import * as types from './types';
import { createCoverageReducers } from '../../../common/coverage/reducers';
import { RdcOSCoverageRecord } from '../../../../records';

const { initialState, reducer } = createCoverageReducers({
  types,
  CoverageRecord: RdcOSCoverageRecord,
});

export default reducer;
export { initialState };
